import { lazy } from "react";

const ReviewPartnerSearch = lazy(() => import("../pages/review/PartnerSearch"));
const ReviewWrite = lazy(() => import("../pages/review/Write"));
const ReviewWriteCompleted = lazy(() => import("../pages/review/Completed"));
const ReviewDetail = lazy(() => import("../pages/review/Detail"));
const ReviewReport = lazy(() => import("../pages/review/Report"));

export const reviewRoutes = [
  // 리뷰 > 업체검색
  { path: "/review/partner-search", element: <ReviewPartnerSearch /> },
  // 리뷰 > 작성 및 수정
  { path: "/review/write", element: <ReviewWrite /> },
  // 리뷰 > 작성 완료
  { path: "/review/completed", element: <ReviewWriteCompleted /> },
  // 리뷰 > 상세
  { path: "/review/detail/:reviewId", element: <ReviewDetail /> },
  // 리뷰 > 신고
  { path: "/review/report/:communityUuid", element: <ReviewReport /> },
];
